import { useInfiniteQuery, useSuspenseQuery } from '@tanstack/react-query';
import { getCollaborativeProviderDetails, getAllCollaborativeProvidersDetails, getCollaborativeProviderActivity, GetCollaborativeProviderActivityFilters } from '@uplift/api';

import { providerQueryKeys } from '../provider/providerQueryKeys';


export const useAllCollaborativeProvidersDetailsQuery = (physicianId: string) => {
  return useSuspenseQuery({
    queryKey: providerQueryKeys.collaborativeProvidersDetails(physicianId),
    queryFn: async () => {
      const response = await getAllCollaborativeProvidersDetails(physicianId);

      return response.data;
    },
  });
};


export const useCollaborativeProviderDetailsQuery = (providerId: string) => {
  return useSuspenseQuery({
    queryKey: providerQueryKeys.collaborativeProviderDetails(providerId),
    queryFn: async () => {
      const response = await getCollaborativeProviderDetails(providerId);

      return response.data;
    },
  });
};


export const useCollaborativeProviderActivityQuery = (providerId: string, filters?: GetCollaborativeProviderActivityFilters) => {
  return useInfiniteQuery({
    queryKey: (
      filters
        ? providerQueryKeys.collaborativeProviderActivityWithFilters(providerId, filters)
        : providerQueryKeys.collaborativeProviderActivity(providerId)
    ),
    queryFn: async ({ pageParam }) => {
      return await getCollaborativeProviderActivity(providerId, { cursor: pageParam, ...filters });
    },
    getNextPageParam: (lastPage) => lastPage?.cursor,
  });
};
